import { useState, useCallback, useEffect } from "react";
import CalcalistPaywallCheckoutMobilePlans, { SubscriptionPlan } from "./calcalistPaywallCheckoutMobilePlans";
import CalcalistPaywallCheckoutMobileFinish from "./calcalistPaywallCheckoutMobilePaymentFinish";
import CalcalistPaywallCheckoutMobilePaymentDetails from "./calcalistPaywallCheckoutMobilePaymentDetails";
import CalcalistPaywallCheckoutMobilePersonalDetails from "./calcalistPaywallCheckoutMobilePersonalDetails";
import { SettingLinks } from "../calcalistPaywallCheckout";
import { useRedirect } from "../../../../../../global/paywall/useRedirect"
import { AuthLogOutLocal, getPaywallSettingsFromLocalStorage } from "../../../../../../global/paywall/authOperations";
import { CustomerAccessData } from "../../../../../../global/paywall/paywallInterfaces";
import { getPaywallAccessData } from "../../../../../../global/paywall/paywallApiUrls";
import * as axios from "axios";
import { hasProductClientId, productClientId } from "../../../../../../global/paywall/paywallUtils";
import { DetailsUpdateMode, DetailUpdateError, useDetailsUpdate } from "../../../../../../global/paywall/useDetailsUpdate";
import PaywallRevalidate from "../../../../paywallRevalidate/desktop/paywallRevalidate";
interface CalcalistPaywallCheckoutMobileComponentaProps {
    settingLinks: SettingLinks;
}

enum CheckoutStep {
    SELECT_PLAN = "בחירת מסלול",
    PERSONAL_DETAILS = "פרטים אישיים",
    PAYMENT_DETAILS = "פרטי תשלום",
    FINISH = "סיום",
}

export const CalcalistPaywallCheckoutMobileComponenta = ({ settingLinks }: CalcalistPaywallCheckoutMobileComponentaProps) => {

    const [currentStepIndex, setCurrentStepIndex] = useState<number>(0);
    const [selectedPlan, setPlan] = useState<SubscriptionPlan>(null);
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const [fallbackUrl, setFallbackUrl] = useState<string>(settingLinks.postPurchase.url);
    useRedirect({ fallbackUrl: fallbackUrl, enabled: shouldRedirect });
    const {
        customerDetails,
        setCustomerDetails,
        revalidationType,
        setRevalidationType,
        setAgreeToTermsOfUse,
        agreeToTermsOfUse,
        error,
        clearError,
        revalidateUser,
        revalidationStep,
        saveCustomerDetails,
        sendRevalidation,
        validateOtp
    } = useDetailsUpdate(DetailsUpdateMode.PURCHASE);

    const [hasCheckedAccess, setHasCheckedAccess] = useState(false);


    useEffect(() => {
        if (customerDetails.email && !hasCheckedAccess) {
            checkForAccess();
            setHasCheckedAccess(true);
        }
    }, [customerDetails, hasCheckedAccess]);

    useEffect(() => {
        if (error === DetailUpdateError.NOT_LOGGED_IN) {
            setFallbackUrl(settingLinks.authPage.url);
            AuthLogOutLocal();
            setShouldRedirect(true);
        }
    }, [error]);


    const checkForAccess = async () => {
        if (!customerDetails.email) {
            return;
        }
        try {
            const response = await axios.get<{ data: CustomerAccessData }>(getPaywallAccessData());
            const accessData = response && response.data && response.data.data as CustomerAccessData;
            const hasProducts = hasProductClientId(accessData.claims, productClientId);
            if (accessData && hasProducts) {
                setFallbackUrl(settingLinks.postPurchase.url);
                setShouldRedirect(true);
            }
        } catch (error) {
            console.error("Error fetching customer access data:", error);
        }
    }

    if (revalidateUser) {
        return <PaywallRevalidate
            userData={revalidateUser}
            step={revalidationStep}
            error={error}
            revalidationType={revalidationType}
            setRevalidationType={setRevalidationType}
            sendRevalidation={sendRevalidation}
            validateOtp={validateOtp}
        />;
    }

    const steps = Object.values(CheckoutStep);

    const nextStep = () => {
        setCurrentStepIndex(Math.min(currentStepIndex + 1, steps.length - 1));
    };

    const prevStep = () => {
        setCurrentStepIndex(Math.max(currentStepIndex - 1, 0));
    };

    const renderStepContent = () => {
        switch (steps[currentStepIndex]) {
            case CheckoutStep.SELECT_PLAN:
                return <CalcalistPaywallCheckoutMobilePlans nextStep={nextStep} setPlan={setPlan} settingLinks={settingLinks} />;
            case CheckoutStep.PERSONAL_DETAILS:
                return <CalcalistPaywallCheckoutMobilePersonalDetails
                    setCustomerDetails={setCustomerDetails}
                    customerDetails={customerDetails}
                    settingLinks={settingLinks}
                    setAgreeToTermsOfUse={setAgreeToTermsOfUse}
                    agreeToTermsOfUse={agreeToTermsOfUse}
                    error={error}
                    clearError={clearError}
                    saveCustomerDetails={saveCustomerDetails}
                    nextStep={nextStep}
                    prevStep={prevStep} />;
        
            case CheckoutStep.PAYMENT_DETAILS:
                return <CalcalistPaywallCheckoutMobilePaymentDetails nextStep={nextStep} prevStep={prevStep} selectedPlan={selectedPlan} />;
            case CheckoutStep.FINISH:
                return <CalcalistPaywallCheckoutMobileFinish setShouldRedirect={setShouldRedirect} nextStep={nextStep} />;
            default:
                return null;
        }
    };


    return (
        <div className="CalcalistPaywallCheckoutComponenta">
            <div className="gradient-background"></div>
            <div className="calcalist-digital-edition-text">המהדורה הדיגיטלית</div>
            {renderStepContent()}
        </div>
    );
};

CalcalistPaywallCheckoutMobileComponenta.siteScriptName = "CalcalistPaywallCheckoutMobileComponenta"
